import { buildURL, fetchJSON, fetchWithAuth } from "../util/fetch-utils";
export default class VelavuApiAssetRoutes {
    //This method returns all of an asset's routes.
    //https://docs.velavu.com/#get-all-routes
    getAllRoutes(assetID, params) {
        const query = {};
        if (params?.since !== undefined) {
            query["since"] = params.since.toISOString();
        }
        if (params?.until !== undefined) {
            query["until"] = params.until.toISOString();
        }
        const url = buildURL(`/assets/${assetID}/routes`, query);
        return fetchJSON(url);
    }
    //This method returns a specific route.
    //https://docs.velavu.com/#get-a-specific-route
    getSpecificRoute(assetID, routeID) {
        return fetchJSON(`/assets/${assetID}/routes/${routeID}`);
    }
    //Delete a Specific Route
    //https://docs.velavu.com/#delete-a-specific-route
    deleteSpecificRoute(assetID, routeID) {
        return fetchWithAuth(`/assets/${assetID}/routes/${routeID}`, {
            method: "DELETE"
        });
    }
}
//# sourceMappingURL=velavu-api-asset-routes.js.map